<template>
  <div>
    <highcharts :options="options"></highcharts>
  </div>
</template>
<script>
import httpHelper from "../../../helpers/httpHelper";
export default {
  name: "linechart",
  props: ["url", "xyfiellds", "title"],
  data() {
    return {
      options: {},
      datas: [],
    };
  },
  watch: {
    url(oldVal, newVal) {
      this.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      if (this.url) {
        httpHelper.getData(this.url).then((res) => {
          if (res.result) {
            this.datas = res.result;
          } else {
            this.datas = res;
          }
          this.getOptions();
        });
      }
    },
    getOptions() {
      var categories = [];
      this.datas.forEach((element) => {
        categories.push(element[this.xyfiellds.x.column]);
      });
      var series_data = [];
      this.datas.forEach((element) => {
        series_data.push(parseInt(element[this.xyfiellds.y.column]));
      });
      this.options = {
        chart: {
          type: "spline",
          style: {
            fontFamily: "IRANSans !important",
          },
        },
        colors: ["#1bc5bd", "#ffa800", "#f64e60", "#8950fc", "#6993ff"],
        title: {
          text: this.title,
        },

        yAxis: {
          title: {
            text: this.xyfiellds.y.name,
          },
          labels: {
            formatter: function () {
              return this.value;
            },
          },
        },

        xAxis: {
          accessibility: {
            rangeDescription: "Range: 2010 to 2017",
          },
          categories: categories,
        },

        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return `<div style='direction:rtl;'><h6 style='text-align:right'> 
              ${this.x} 
              </h6>
              ${
                this.y.toLocaleString()
              }
              </div>`;
          },
        },

        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },

        series: [
          {
            name: this.xyfiellds.x.name,
            data: series_data,
          },
        ],

        responsive: {
          rules: [
            {
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
      };
    },
  },
};
</script>